import { createAction } from 'redux-act';

export const getProgramIdeActivitySets = createAction();
export const getProgramIdeActivitySetsError = createAction();
export const receivedProgramIdeActivitySets = createAction();

export const getUserIdeActivitySets = createAction();
export const getUserIdeActivitySetsError = createAction();
export const receivedUserIdeActivitySets = createAction();
